import { Component, Input } from '@angular/core';
import { Allergens } from 'src/interfaces/enums.model';

/**
 * Монохромная иконка аллергена (assets/allergens — тот же набор, что в приложении Edim).
 * SVG — маской: цвет берётся из currentColor
 */
@Component({
    selector: 'app-allergen-icon',
    template: `<span class="allergen-icon" [ngStyle]="style"></span>`,
    styleUrls: ['./menu-allergen-icon.component.css'],
    standalone: false
})
export class MenuAllergenIconComponent {
  @Input() allergen: Allergens = Allergens.unknown;
  @Input() size: number = 16;

  get style(): Record<string, string> {
    const url = `url(assets/allergens/${Allergens[this.allergen]}.svg)`;
    return {
      'width.px': `${this.size}`,
      'height.px': `${this.size}`,
      'mask-image': url,
      '-webkit-mask-image': url,
    };
  }
}
